import { useContext } from "react"

import { GraphContext } from "./GraphContext"

export function useGraphContext() {
  return useContext(GraphContext)
}
